import React, { useState } from 'react';
import './ProductSelectorModal.css';

const ProductSelectorModal = ({ onClose, onSelect }) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchProducts = async () => {
        if (!searchTerm.trim()) return;
        setLoading(true);
        try {
            const res = await fetch(`/api/produtos?search=${encodeURIComponent(searchTerm)}`);
            if (res.ok) {
                const data = await res.json();
                setProducts(data);
            }
        } catch (error) {
            console.error('Erro ao buscar produtos:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content product-selector-modal">
                <div className="win-title">
                    Selecionar Produto Existente
                    <button className="btn-close" onClick={onClose}>×</button>
                </div>
                <div className="win-body">
                    <div className="search-box">
                        <input
                            type="text"
                            placeholder="Buscar produto por nome..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            onKeyDown={(e) => e.key === 'Enter' && fetchProducts()}
                            autoFocus
                        />
                        <button className="btn-classic" onClick={fetchProducts}>Buscar</button>
                    </div>

                    <div className="selector-list">
                        {loading ? <p style={{ padding: '10px' }}>Buscando...</p> :
                            products.length === 0 ? (
                                <p style={{ padding: '10px' }}>
                                    {searchTerm ? 'Nenhum produto encontrado.' : 'Digite um nome para pesquisar.'}
                                </p>
                            ) : (
                                products.map(p => (
                                    <div key={p.ID} className="selector-item" onClick={() => onSelect(p)}>
                                        <strong>{p.NomeProduto}</strong>
                                        <span>ID: #{p.ID}</span>
                                    </div>
                                ))
                            )
                        }
                    </div>
                </div>
                <div className="modal-footer" style={{ padding: '10px', display: 'flex', justifyContent: 'flex-end', borderTop: '1px solid #808080' }}>
                    <button className="btn-classic danger" onClick={onClose}>Cancelar</button>
                </div>
            </div>
        </div>
    );
};

export default ProductSelectorModal;
